import { render, staticRenderFns } from "./NolaNovelNotification.vue?vue&type=template&id=208641f5&scoped=true"
import script from "./NolaNovelNotification.vue?vue&type=script&lang=ts"
export * from "./NolaNovelNotification.vue?vue&type=script&lang=ts"
import style0 from "./NolaNovelNotification.vue?vue&type=style&index=0&id=208641f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208641f5",
  null
  
)

export default component.exports